module.exports = __webpack_public_path__ + "static/media/plan_deepct.7a0873f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/plan_deepct.svg
// module id = 870
// module chunks = 0